export const getters = {

  screenWidth: (state) => state.screenWidth,

  screenType: (state) => state.screenType,

  menuIndex: (state) => state.menuIndex,

  getAlbum: (state) => {
    if (state.album.isCreated) {
      return state.album;
    } else {
      return false;
    }
  },

  getBlog: (state) => {
    if (state.blog.isCreated) {
      return state.blog;
    } else {
      return false;
    }
  },

}



// WEBPACK FOOTER //
// ./src/store/getters.js